import { get } from "lodash";
import { CONTACT_POINT_SYSTEM, REGEX_EXPS } from "utils/constants";
import { isValidLocalPhoneNumber } from "utils/helpers/phone";

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidQuoteEmail = (email) => {
  if (email == null) return false;
  const value = String(email).trim();
  return EMAIL_PATTERN.test(value);
};

export const areQuoteContactFieldsValid = (values) => {
  const firstname = String(get(values, "contact.user.firstname") || "").trim();
  const lastname = String(get(values, "contact.user.lastname") || "").trim();
  const phone = String(
    get(values, `contact.telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`) || "",
  ).replace(/\s+/g, "");
  const phoneIsValid = Boolean(phone) && isValidLocalPhoneNumber(phone);
  return (
    REGEX_EXPS.name.test(firstname) &&
    REGEX_EXPS.name.test(lastname) &&
    phoneIsValid
  );
};

export const resolveQuoteActionsState = ({
  hasSelectedPlans,
  email,
  isFormValid = true,
}) => ({
  downloadDisabled: !hasSelectedPlans,
  sendDisabled: !hasSelectedPlans || !isValidQuoteEmail(email) || !isFormValid,
});
